import { put, call, all } from 'redux-saga/effects';
import { gridChange } from '../../../helper/yoyUtils';
import { getData } from '../../service/getDataService';
import APIENDPOINTS from '../../../constants/apiconstants';
import {
	getItemBasicInfoSuccess,
	getItemBasicInfoFailure,
	setItemRetailOnHandInventory,
	setItemUnitOnHandInventory,
	getItemNetSalesSummaryCardsSuccess,
	getItemNetSalesSummaryCardsFailure,
	getItemInStockSummaryCardsSuccess,
	getItemInStockSummaryCardsFailure,
	getItemStoreCountSummaryCardsSuccess,
	getItemStoreCountSummaryCardsFailure,
	getItemNilPickRateSummaryCardsSuccess,
	getItemNilPickRateSummaryCardsFailure,
	itemChannelBreakdownSuccess,
	itemChannelBreakdownFailure,
	itemNetSalesSuccess,
	itemNetSalesFailure,
	itemUnitsSuccess,
	itemUnitsFailure,
	itemRelativeNetSalesSuccess,
	itemRelativeNetSalesFailure,
	itemRelativeUnitsSuccess,
	itemRelativeUnitsFailure,
	unitsChannelBreakdownSuccess,
	unitsChannelBreakdownFailure,
	getItemOnHandSuccess,
	getItemOnHandFailure,
	getItemOnHandUnitsSuccess,
	getItemOnHandUnitsFailure,
	getItemOnOrderSuccess,
	getItemOnOrderFailure,
	getItemOnOrderUnitsSuccess,
	getItemOnOrderUnitsFailure,
	getItemDCToStoreSuccess,
	getItemDCToStoreFailure,
	getItemDCToStoreUnitsSuccess,
	getItemDCToStoreUnitsFailure,
	getItemInWhseSuccess,
	getItemInWhseFailure,
	getItemInWhseUnitsSuccess,
	getItemInWhseUnitsFailure,
	getItemInvTrendSuccess,
	getItemInvTrendFailure,
	getItemInStockSuccess,
	getItemInStockFailure,
	getNilPickRateSuccess,
	getNilPickRateFailure,
	getFirstTimeRateSuccess,
	getFirstTimeRateFailure,
	getPreSubstituteSuccess,
	getPreSubstituteFailure,
	getPostSubstituteSuccess,
	getPostSubstituteFailure,
	getItemNetSalesMapSummarySuccess,
	getItemNetSalesMapSummaryFailure,
	getWeekOfSupplyStoreSuccess,
	getWeekOfSupplyStoreFailure,
	getWeekOfSupplyDCSuccess,
	getWeekOfSupplyDCFailure,
	getItemLocationGridStateSuccess,
	getItemLocationGridStateFailure,
	getItemLocationGridStoreSuccess,
	getItemLocationGridStoreFailure,
	setMapConfig,
} from '../../actions/itemDrillDownActions';
import {
	parseOnHandResponse,
	parseSummary,
	parseTrendChartResponse,
	parseRelativeResponse,
	parseMapSummaryResponse,
	getUrlParams,
} from './util';
import { formatInventoryTrendsResponse } from '../inventory/util';
import { getCustomWeekParams } from '../utils';
import usStateMapCoordinates from '../../../common/components/map/geo-data/usStateMapCoordinates';

export const getState = (id) => {
	const data = usStateMapCoordinates.features.find((item) => {
		return item.properties.id?.toLowerCase() === id?.toLowerCase();
	});

	return data ? data?.properties?.name : 'Others';
};

export function* getItemBasicInfo(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.SUMMARY_URL
		}/summary/item/category/${categoryId}/channel/OMNI/period/${period}?wmItemNbr=${itemNum}${getCustomWeekParams(
			startDate,
			endDate,
			period
		)}`;

		const response = yield call(getData, apiUrl, portalUserContext.result);

		if (response?.statusCode > 200) {
			yield put(getItemBasicInfoFailure(response?.statusCode));
			return;
		}
		const data = response?.json?.result?.result;
		yield put(
			getItemBasicInfoSuccess({
				...data[0],
				catName: data[0]?.catName,
				subCatName: data[0]?.subCatName,
				itemName: data[0]?.itemName,
				itemId: data[0]?.itemId,
				upc: data[0]?.wmUpcNbr,
				brandName: data[0]?.brandName,
				supplier: data[0]?.parentCompany,
				supplierId: data[0]?.supplierId,
			})
		);
	} catch (error) {
		yield put(getItemBasicInfoFailure(error));
	}
}

export function* getItemUnitOnHandInventory(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;

		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/ON_HAND/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=units&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const unitResponse = yield call(getData, apiUrl, portalUserContext.result);

		if (unitResponse?.statusCode > 200) {
			yield put(setItemUnitOnHandInventory(unitResponse?.statusCode, false));
		} else {
			yield put(
				setItemUnitOnHandInventory({
					data: parseOnHandResponse(unitResponse),
					summary: unitResponse?.json?.result?.summary,
				})
			);
		}
	} catch (error) {
		yield put(setItemUnitOnHandInventory(error, false));
	}
}

export function* getItemRetailOnHandInventory(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;

		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/ON_HAND/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const retailResponse = yield call(
			getData,
			apiUrl,
			portalUserContext.result
		);

		if (retailResponse?.statusCode > 200) {
			yield put(
				setItemRetailOnHandInventory(retailResponse?.statusCode, false)
			);
		} else {
			yield put(
				setItemRetailOnHandInventory({
					data: parseOnHandResponse(retailResponse),
					summary: retailResponse?.json?.result?.summary,
				})
			);
		}
	} catch (error) {
		setItemRetailOnHandInventory(500, false);
	}
}

export function* getItemNetSalesSummaryCards(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;

		const netSalesAPI = `${
			APIENDPOINTS.SUMMARY_URL
		}/card/NET_SALES/category/${categoryId}/channel/OMNI/period/${period}?wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;
		const response = yield call(getData, netSalesAPI, portalUserContext.result);

		if (response?.statusCode > 200) {
			yield put(getItemNetSalesSummaryCardsFailure(response?.statusCode));
		} else {
			yield put(
				getItemNetSalesSummaryCardsSuccess({
					...parseSummary(response).netSales(),
				})
			);
		}
	} catch (error) {
		yield put(getItemNetSalesSummaryCardsFailure(error));
	}
}
export function* getItemInStockSummaryCards(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const inStockAPI = `${
			APIENDPOINTS.SUMMARY_URL
		}/card/IN_STOCK/category/${categoryId}/channel/OMNI/period/${period}?wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;
		const response = yield call(getData, inStockAPI, portalUserContext.result);

		if (response?.statusCode > 200) {
			yield put(getItemInStockSummaryCardsFailure(response?.statusCode));
		} else {
			yield put(
				getItemInStockSummaryCardsSuccess({
					...parseSummary(response).inStock(),
				})
			);
		}
	} catch (error) {
		yield put(getItemInStockSummaryCardsFailure(error));
	}
}
export function* getItemStoreCountSummaryCards(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const storeCountAPI = `${
			APIENDPOINTS.SUMMARY_URL
		}/card/STORE_COUNT/category/${categoryId}/channel/OMNI/period/${period}?wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const response = yield call(
			getData,
			storeCountAPI,
			portalUserContext.result
		);
		if (response?.statusCode > 200) {
			yield put(getItemStoreCountSummaryCardsFailure(response?.statusCode));
		} else {
			yield put(
				getItemStoreCountSummaryCardsSuccess({
					...parseSummary(response).storeCount(),
				})
			);
		}
	} catch (error) {
		yield put(getItemStoreCountSummaryCardsFailure(error));
	}
}
export function* getItemNilPickRateSummaryCards(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;

		const nilPickRateAPI = `${
			APIENDPOINTS.SUMMARY_URL
		}/card/NIL_PICK_RATE/category/${categoryId}/channel/OMNI/period/${period}?wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;
		const response = yield call(
			getData,
			nilPickRateAPI,
			portalUserContext.result
		);
		if (response?.statusCode > 200) {
			yield put(getItemNilPickRateSummaryCardsFailure(response?.statusCode));
		} else {
			yield put(
				getItemNilPickRateSummaryCardsSuccess({
					...parseSummary(response).nilPickRate(),
				})
			);
		}
	} catch (error) {
		yield put(getItemNilPickRateSummaryCardsFailure(error));
	}
}

export function* getItemChannelBreakdown(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;

		const apiUrl = `${
			APIENDPOINTS.BREAKDOWN_URL
		}/NET_SALES/category/${categoryId}/channel/OMNI/period/${period}?wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const response = yield call(getData, apiUrl, portalUserContext.result);

		if (response?.statusCode > 200) {
			yield put(itemChannelBreakdownFailure(response?.statusCode));
			return;
		}

		yield put(
			itemChannelBreakdownSuccess({
				data: response?.json?.result || {},
			})
		);
	} catch (error) {
		yield put(itemChannelBreakdownFailure(500));
	}
}

export function* getItemNetSales(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/NET_SALES/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const response = yield call(getData, apiUrl, portalUserContext.result);

		if (response?.statusCode >= 400) {
			yield put(itemNetSalesFailure(response?.statusCode));
			return;
		}

		yield put(itemNetSalesSuccess({ ...parseTrendChartResponse(response) }));
	} catch (error) {
		yield put(itemNetSalesFailure(error));
	}
}

export function* getItemUnits(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/SALES_VOLUME/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const response = yield call(getData, apiUrl, portalUserContext.result);

		if (response?.statusCode >= 400) {
			yield put(itemUnitsFailure(response?.statusCode));
			return;
		}

		yield put(itemUnitsSuccess({ ...parseTrendChartResponse(response) }));
	} catch (error) {
		yield put(itemUnitsFailure(error));
	}
}

export function* getItemRelativeNetSales(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.SUMMARY_URL
		}/relativecard/NET_SALES/item/category/${categoryId}/channel/OMNI/period/${period}?wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const response = yield call(getData, apiUrl, portalUserContext.result);

		if (response?.statusCode >= 400) {
			yield put(itemRelativeNetSalesFailure(response?.statusCode));
			return;
		}

		yield put(itemRelativeNetSalesSuccess(parseRelativeResponse(response)));
	} catch (error) {
		yield put(itemRelativeNetSalesFailure(error));
	}
}

export function* getItemRelativeUnits(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.SUMMARY_URL
		}/relativecard/SALES_VOLUME/item/category/${categoryId}/channel/OMNI/period/${period}?wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const response = yield call(getData, apiUrl, portalUserContext.result);

		if (response?.statusCode >= 400) {
			yield put(itemRelativeUnitsFailure(response?.statusCode));
			return;
		}

		yield put(itemRelativeUnitsSuccess(parseRelativeResponse(response)));
	} catch (error) {
		yield put(itemRelativeUnitsFailure(error));
	}
}

export function* getUnitsChannelBreakdown(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;

		const apiUrl = `${
			APIENDPOINTS.BREAKDOWN_URL
		}/SALES_VOLUME/category/${categoryId}/channel/OMNI/period/${period}?wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const response = yield call(getData, apiUrl, portalUserContext.result);

		if (response?.statusCode > 200) {
			yield put(unitsChannelBreakdownFailure(response?.statusCode));
			return;
		}

		yield put(
			unitsChannelBreakdownSuccess({
				data: response?.json?.result || {},
			})
		);
	} catch (error) {
		yield put(unitsChannelBreakdownFailure(500));
	}
}

export function* getItemInventoryOnHand(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/ON_HAND/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const retailResponse = yield call(
			getData,
			apiUrl,
			portalUserContext.result
		);
		if (retailResponse?.statusCode > 200) {
			yield put(getItemOnHandFailure(retailResponse?.statusCode));
		} else {
			yield put(
				getItemOnHandSuccess({
					data: parseOnHandResponse(retailResponse),
					summary: retailResponse?.json?.result?.summary,
				})
			);
		}
	} catch (error) {
		yield put(getItemOnHandFailure(500));
	}
}

export function* getItemInventoryOnHandUnit(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/ON_HAND/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=units&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const unitResponse = yield call(getData, apiUrl, portalUserContext.result);

		if (unitResponse?.statusCode > 200) {
			yield put(getItemOnHandUnitsFailure(unitResponse?.statusCode));
		} else {
			yield put(
				getItemOnHandUnitsSuccess({
					data: parseOnHandResponse(unitResponse),
					summary: unitResponse?.json?.result?.summary,
				})
			);
		}
	} catch (error) {
		yield put(getItemOnHandUnitsFailure(500));
	}
}

export function* getItemInventoryOnOrder(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/ON_ORDER/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const retailResponse = yield call(
			getData,
			apiUrl,
			portalUserContext.result
		);

		if (retailResponse?.statusCode > 200) {
			yield put(getItemOnOrderFailure(retailResponse?.statusCode));
		} else {
			yield put(
				getItemOnOrderSuccess({
					data: parseOnHandResponse(retailResponse),
					summary: retailResponse?.json?.result?.summary,
				})
			);
		}
	} catch (error) {
		yield put(getItemOnOrderFailure(500));
	}
}

export function* getItemInventoryOnOrderUnit(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/ON_ORDER/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=units&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const unitResponse = yield call(getData, apiUrl, portalUserContext.result);
		if (unitResponse?.statusCode > 200) {
			yield put(getItemOnOrderUnitsFailure(unitResponse?.statusCode));
		} else {
			yield put(
				getItemOnOrderUnitsSuccess({
					data: parseOnHandResponse(unitResponse),
					summary: unitResponse?.json?.result?.summary,
				})
			);
		}
	} catch (error) {
		yield put(getItemOnOrderUnitsFailure(500));
	}
}

export function* getItemInventoryDCToStore(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/DC_TO_STORE/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const retailResponse = yield call(
			getData,
			apiUrl,
			portalUserContext.result
		);

		if (retailResponse?.statusCode > 200) {
			yield put(getItemDCToStoreFailure(retailResponse?.statusCode));
		} else {
			yield put(
				getItemDCToStoreSuccess({
					data: parseOnHandResponse(retailResponse),
					summary: retailResponse?.json?.result?.summary,
				})
			);
		}
	} catch (error) {
		yield put(getItemDCToStoreFailure(500));
	}
}

export function* getItemInventoryDCToStoreUnit(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/DC_TO_STORE/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=units&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const unitResponse = yield call(getData, apiUrl, portalUserContext.result);

		if (unitResponse?.statusCode > 200) {
			yield put(getItemDCToStoreUnitsFailure(unitResponse?.statusCode));
		} else {
			yield put(
				getItemDCToStoreUnitsSuccess({
					data: parseOnHandResponse(unitResponse),
					summary: unitResponse?.json?.result?.summary,
				})
			);
		}
	} catch (error) {
		yield put(getItemDCToStoreUnitsFailure(500));
	}
}

export function* getItemInventoryInWhse(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/IN_WHSE/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const retailResponse = yield call(
			getData,
			apiUrl,
			portalUserContext.result
		);

		if (retailResponse?.statusCode > 200) {
			yield put(getItemInWhseFailure(retailResponse?.statusCode));
		} else {
			yield put(
				getItemInWhseSuccess({
					data: parseOnHandResponse(retailResponse),
					summary: retailResponse?.json?.result?.summary,
				})
			);
		}
	} catch (error) {
		yield put(getItemInWhseFailure(500));
	}
}

export function* getItemInventoryInWhseUnit(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/IN_WHSE/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=units&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const unitResponse = yield call(getData, apiUrl, portalUserContext.result);

		if (unitResponse?.statusCode > 200) {
			yield put(getItemInWhseUnitsFailure(unitResponse?.statusCode));
		} else {
			yield put(
				getItemInWhseUnitsSuccess({
					data: parseOnHandResponse(unitResponse),
					summary: unitResponse?.json?.result?.summary,
				})
			);
		}
	} catch (error) {
		yield put(getItemInWhseUnitsFailure(500));
	}
}

export function* getItemInventoryTrendSaga(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/NET_SALES_ON_HAND_TRENDS/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=units&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const inventoryTrend = yield call(
			getData,
			apiUrl,
			portalUserContext.result
		);

		if (inventoryTrend?.statusCode > 200) {
			yield put(getItemInvTrendFailure(inventoryTrend?.statusCode));
		} else {
			const itemTrend = formatInventoryTrendsResponse(
				inventoryTrend.json?.result
			);

			yield put(getItemInvTrendSuccess(itemTrend));
		}
	} catch (error) {
		yield put(getItemInvTrendFailure(500));
	}
}

export function* getItemInStockSaga(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.TREND_URL
		}/trendChart/IN_STOCK/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const itemInStockData = yield call(
			getData,
			apiUrl,
			portalUserContext.result
		);

		if (itemInStockData?.statusCode > 200) {
			yield put(getItemInStockFailure(itemInStockData?.statusCode));
		} else {
			const getIteminStockData = (trendData) => {
				return {
					data: trendData?.json?.result?.data?.map((item) => ({
						...item,
						bus_dt: item?.busDt,
						wm_wk_nbr: item.wmWkNbr,
						wm_yr_wk_nbr: item.wmYrWkNbr,
						ly_value: item.lyValue,
						ty_value: item.tyValue,
					})),
					summary: {
						total_ty: trendData?.json?.result?.summary?.total,
						diff_perc: trendData?.json?.result?.summary?.yoy,
					},
				};
			};

			const itemInStock = getIteminStockData(itemInStockData);

			yield put(
				getItemInStockSuccess({
					itemInStock: itemInStock,
				})
			);
		}
	} catch (error) {
		yield put(getItemInStockFailure(500));
	}
}

export function* getNilPickRateSaga(action) {
	const {
		portalUserContext,
		categoryId,
		period,
		itemNum,
		subCatId,
		brandId,
		startDate,
		endDate,
	} = action.payload;

	try {
		const nilPickRateData = yield call(
			getData,
			`${
				APIENDPOINTS.TREND_URL
			}/trendChart/NIL_PICK_RATE/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
				subCatId,
				brandId
			)}${getCustomWeekParams(startDate, endDate, period)}`,
			portalUserContext.result
		);

		if (nilPickRateData?.statusCode >= 400) {
			throw new Error(nilPickRateData?.statusCode);
		}

		yield put(
			getNilPickRateSuccess({
				nilPickRateData: nilPickRateData.json?.result,
			})
		);
	} catch (error) {
		yield put(getNilPickRateFailure(error));
	}
}

export function* getFirstTimePickRateSaga(action) {
	const {
		portalUserContext,
		categoryId,
		period,
		itemNum,
		subCatId,
		brandId,
		startDate,
		endDate,
	} = action.payload;

	try {
		const firstTimePickRateData = yield call(
			getData,
			`${
				APIENDPOINTS.TREND_URL
			}/trendChart/FIRST_TIME_PICK_RATE/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
				subCatId,
				brandId
			)}${getCustomWeekParams(startDate, endDate, period)}`,
			portalUserContext.result
		);

		if (firstTimePickRateData?.statusCode >= 400) {
			throw new Error(firstTimePickRateData?.statusCode);
		}

		yield put(
			getFirstTimeRateSuccess({
				firstTimePickRateData: firstTimePickRateData?.json?.result,
			})
		);
	} catch (error) {
		yield put(getFirstTimeRateFailure(error));
	}
}

export function* getPreSubstituteRateSaga(action) {
	const {
		portalUserContext,
		categoryId,
		period,
		itemNum,
		subCatId,
		brandId,
		startDate,
		endDate,
	} = action.payload;

	try {
		const preSubtituteRateData = yield call(
			getData,
			`${
				APIENDPOINTS.TREND_URL
			}/trendChart/PRE_SUBSTITUTE_RATE/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
				subCatId,
				brandId
			)}${getCustomWeekParams(startDate, endDate, period)}`,
			portalUserContext.result
		);

		if (preSubtituteRateData?.statusCode >= 400) {
			throw new Error(preSubtituteRateData?.statusCode);
		}

		yield put(
			getPreSubstituteSuccess({
				preSubtituteRateData: preSubtituteRateData.json?.result,
			})
		);
	} catch (error) {
		yield put(getPreSubstituteFailure(error));
	}
}

export function* getPostSubstituteRateSaga(action) {
	const {
		portalUserContext,
		categoryId,
		period,
		itemNum,
		subCatId,
		brandId,
		startDate,
		endDate,
	} = action.payload;

	try {
		const postSubtituteRateData = yield call(
			getData,
			`${
				APIENDPOINTS.TREND_URL
			}/trendChart/POST_SUBSTITUTE_RATE/item/category/${categoryId}/channel/OMNI/period/${period}?trendType=value&wmItemNbr=${itemNum}${getUrlParams(
				subCatId,
				brandId
			)}${getCustomWeekParams(startDate, endDate, period)}`,
			portalUserContext.result
		);

		if (postSubtituteRateData?.statusCode >= 400) {
			throw new Error(postSubtituteRateData?.statusCode);
		}

		yield put(
			getPostSubstituteSuccess({
				postSubtituteRateData: postSubtituteRateData.json?.result,
			})
		);
	} catch (error) {
		yield put(getPostSubstituteFailure(error));
	}
}

export function* getNetSalesMapSummarySaga(action) {
	try {
		const {
			portalUserContext,
			categoryId,
			period,
			itemNum,
			subCatId,
			brandId,
			startDate,
			endDate,
		} = action.payload;
		const apiUrl = `${
			APIENDPOINTS.MAP_SUMMARY_URL
		}/mapsummary/NET_SALES/mapsummary/category/${categoryId}/channel/OMNI/period/${period}?wmItemNbr=${itemNum}${getUrlParams(
			subCatId,
			brandId
		)}${getCustomWeekParams(startDate, endDate, period)}`;

		const response = yield call(getData, apiUrl, portalUserContext.result);
		if (response?.statusCode >= 400) {
			yield put(getItemNetSalesMapSummaryFailure(response?.statusCode));
			return;
		}

		yield put(
			getItemNetSalesMapSummarySuccess({
				...parseMapSummaryResponse(response),
			})
		);
	} catch (error) {
		yield put(getItemNetSalesMapSummaryFailure(error));
	}
}

export function* getWeekOfSupplyStoreSaga(action) {
	const { portalUserContext, itemNum, period, startDate, endDate } =
		action.payload;

	const urlOnHand = `${
		APIENDPOINTS.TREND_URL
	}/trendChart/ON_HAND/item/${itemNum}/channel/OMNI/period/${period}?wosType=STORE${getCustomWeekParams(
		startDate,
		endDate,
		period
	)}`;
	const urlOnOrder = `${
		APIENDPOINTS.TREND_URL
	}/trendChart/ON_ORDER/item/${itemNum}/channel/OMNI/period/${period}?wosType=STORE${getCustomWeekParams(
		startDate,
		endDate,
		period
	)}`;
	const urlInWhse = `${
		APIENDPOINTS.TREND_URL
	}/trendChart/IN_WHSE/item/${itemNum}/channel/OMNI/period/${period}?wosType=STORE${getCustomWeekParams(
		startDate,
		endDate,
		period
	)}`;
	const urlInTransit = `${
		APIENDPOINTS.TREND_URL
	}/trendChart/IN_TRANSIT/item/${itemNum}/channel/OMNI/period/${period}?wosType=STORE${getCustomWeekParams(
		startDate,
		endDate,
		period
	)}`;

	try {
		const weekOfSupplyStore = yield all([
			call(getData, urlOnHand, portalUserContext.result),
			call(getData, urlOnOrder, portalUserContext.result),
			call(getData, urlInWhse, portalUserContext.result),
			call(getData, urlInTransit, portalUserContext.result),
		]);
		if (weekOfSupplyStore[0]?.statusCode > 200) {
			throw new Error(weekOfSupplyStore[0]?.statusCode);
		}

		yield put(
			getWeekOfSupplyStoreSuccess({
				weekOfSupplyStore: {
					ON_HAND: weekOfSupplyStore[0].json?.result,
					ON_ORDER: weekOfSupplyStore[1].json?.result,
					IN_WHSE: weekOfSupplyStore[2].json?.result,
					IN_TRANSIT: weekOfSupplyStore[3].json?.result,
				},
			})
		);
	} catch (error) {
		yield put(getWeekOfSupplyStoreFailure(Number(error.message)));
	}
}

export function* getWeekOfSupplyDCSaga(action) {
	const { portalUserContext, itemNum, period, startDate, endDate } =
		action.payload;

	const urlTotal = `${
		APIENDPOINTS.TREND_URL
	}/trendChart/TOTAL/item/${itemNum}/channel/OMNI/period/${period}?wosType=DC${getCustomWeekParams(
		startDate,
		endDate,
		period
	)}`;
	const urlOnHand = `${
		APIENDPOINTS.TREND_URL
	}/trendChart/ON_HAND/item/${itemNum}/channel/OMNI/period/${period}?wosType=DC${getCustomWeekParams(
		startDate,
		endDate,
		period
	)}`;
	const urlOnOrder = `${
		APIENDPOINTS.TREND_URL
	}/trendChart/ON_ORDER/item/${itemNum}/channel/OMNI/period/${period}?wosType=DC${getCustomWeekParams(
		startDate,
		endDate,
		period
	)}`;
	try {
		const weekOfSupplyDC = yield all([
			call(getData, urlTotal, portalUserContext.result),
			call(getData, urlOnHand, portalUserContext.result),
			call(getData, urlOnOrder, portalUserContext.result),
		]);

		if (weekOfSupplyDC[0]?.statusCode > 200) {
			throw new Error(weekOfSupplyDC[0]?.statusCode);
		}

		yield put(
			getWeekOfSupplyDCSuccess({
				weekOfSupplyDC: {
					TOTAL: weekOfSupplyDC[0].json?.result,
					ON_HAND: weekOfSupplyDC[1].json?.result,
					ON_ORDER: weekOfSupplyDC[2].json?.result,
				},
			})
		);
	} catch (error) {
		yield put(getWeekOfSupplyDCFailure(Number(error.message)));
	}
}

export function* getItemLocationGridStoreData(action) {
	const {
		portalUserContext,
		categoryId,
		timePeriod,
		itemNum,
		startDate,
		endDate,
	} = action.payload;

	try {
		const urlTop = `${
			APIENDPOINTS.GRID_URL
		}/sales/NET_SALES/item/by/location/category/${categoryId}/channel/STORE/period/${timePeriod}?wmItemNbr=${itemNum}&viewBy=store&sortBy=top${
			timePeriod === -1 ? `&startWeek=${startDate}&endWeek=${endDate}` : ''
		}`;
		const urlBottom = `${
			APIENDPOINTS.GRID_URL
		}/sales/NET_SALES/item/by/location/category/${categoryId}/channel/STORE/period/${timePeriod}?wmItemNbr=${itemNum}&viewBy=store&sortBy=bottom${
			timePeriod === -1 ? `&startWeek=${startDate}&endWeek=${endDate}` : ''
		}`;

		const [locationGridDataTop, locationGridDataBottom] = yield all([
			call(getData, urlTop, portalUserContext.result),
			call(getData, urlBottom, portalUserContext.result),
		]);

		if (locationGridDataTop?.statusCode >= 400) {
			throw new Error(locationGridDataTop?.statusCode);
		}

		const getStoreGridData = (locationGridData) => {
			return locationGridData?.json?.result?.rows?.map((item) => ({
				store: `${item.id}`,
				firstColumn: `${item.name}`,
				netSales: item.tyValue,
				pickup: gridChange(item.pickup?.tyValue),
				delivery: gridChange(item.delivery?.tyValue),
				bis: gridChange(item.bis?.tyValue),
				sfs: gridChange(item.sfs?.tyValue),
				inventory: gridChange(item.inventory?.tyValue),
				inStock: gridChange(item.inStock?.tyValue),
				nilPickRate: gridChange(item.nilPickRate?.tyValue),
				change: gridChange(item.yoy),
				sales: gridChange(item.tyValue),
				dataKey: `${item.id}`,
			}));
		};

		yield put(
			getItemLocationGridStoreSuccess({
				locationGridData: {
					topList: getStoreGridData(locationGridDataTop),
					bottomList: getStoreGridData(locationGridDataBottom),
				},
				numberOfRecords: locationGridDataTop.json.result.numberOfRecords,
			})
		);
	} catch (error) {
		yield put(getItemLocationGridStoreFailure(error));
	}
}

export function* getItemLocationGridStateData(action) {
	const {
		portalUserContext,
		categoryId,
		timePeriod,
		itemNum,
		startDate,
		endDate,
	} = action.payload;

	const urlTop = `${
		APIENDPOINTS.GRID_URL
	}/sales/NET_SALES/item/by/location/category/${categoryId}/channel/STORE/period/${timePeriod}?wmItemNbr=${itemNum}&viewBy=state&sortBy=top${
		timePeriod === -1 ? `&startWeek=${startDate}&endWeek=${endDate}` : ''
	}`;

	const urlBottom = `${
		APIENDPOINTS.GRID_URL
	}/sales/NET_SALES/item/by/location/category/${categoryId}/channel/STORE/period/${timePeriod}?wmItemNbr=${itemNum}&viewBy=state&sortBy=bottom${
		timePeriod === -1 ? `&startWeek=${startDate}&endWeek=${endDate}` : ''
	}`;

	try {
		const [locationGridDataTop, locationGridDataBottom] = yield all([
			call(getData, urlTop, portalUserContext.result),
			call(getData, urlBottom, portalUserContext.result),
		]);

		if (locationGridDataTop?.statusCode >= 400) {
			throw new Error(locationGridDataTop?.statusCode);
		}

		const getStateGridData = (locationGridData) => {
			return locationGridData?.json?.result?.rows?.map((item) => ({
				state: getState(item.id),
				firstColumn: getState(item.id),
				netSales: gridChange(item.tyValue),
				pickup: gridChange(item.pickup?.tyValue),
				delivery: gridChange(item.delivery?.tyValue),
				bis: gridChange(item.bis?.tyValue),
				sfs: gridChange(item.sfs?.tyValue),
				inventory: gridChange(item.inventory?.tyValue),
				inStock: gridChange(item.inStock?.tyValue),
				nilPickRate: gridChange(item.nilPickRate?.tyValue),
				change: gridChange(item.yoy),
				sales: gridChange(item.tyValue),
				dataKey: `${item.id}`,
			}));
		};

		yield put(
			getItemLocationGridStateSuccess({
				locationGridData: {
					topList: getStateGridData(locationGridDataTop),
					bottomList: getStateGridData(locationGridDataBottom),
				},
				numberOfRecords: locationGridDataTop.json.result.numberOfRecords,
			})
		);
	} catch (error) {
		yield put(getItemLocationGridStateFailure(error));
	}
}

export function* getMapConfig(action) {
	try {
		const { portalUserContext } = action.payload;
		const { json } = yield call(
			getData,
			`${APIENDPOINTS.SEARCH_URL}/map/key`,
			portalUserContext.result
		);
		yield put(
			setMapConfig({
				success: true,
				map: { apiKey: json.MAP_KEY, keyPath: json.MAP_KEY_PATH },
			})
		);
	} catch (error) {
		yield put(
			setMapConfig({
				success: false,
				error: error.message,
			})
		);
	}
}
